import { formatAddressParagraph } from "@/common/components/AddressSuggestionsModal/address-suggestions-modal.util";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { lcrProgressFor } from "@/pages/OrderTracking/Lcr/lcr-progress.util";
import type {
  OrderedItem,
  OrderTrackingView,
  SummaryRow,
} from "@/pages/OrderTracking/order-tracking.types";
import {
  LCR_DELIVERY_METHOD,
  LcrOrder,
  LcrReplacedDevice,
  LcrSubmission,
} from "@/services/orders/lcr-order.types";

const SUMMARY_STRINGS = "orderTracking.summary";
const LCR_SUMMARY_STRINGS = "orderTracking.lcr.summary";
const CHOOSE_DELIVERY_STRINGS = "replacement.chooseDelivery";

const deviceName = ({ make, model }: LcrReplacedDevice): string => `${make} ${model}`;

const orderedItem = ({ selectedDevice, submission }: LcrOrder): OrderedItem => ({
  name: deviceName(selectedDevice),
  details: submission.preferredKeyboardLayout ? [submission.preferredKeyboardLayout] : [],
});

const deliveryRows = ({ deliveryMethod, shippingAddress }: LcrSubmission): SummaryRow[] => {
  if (deliveryMethod === LCR_DELIVERY_METHOD.shipToHome) {
    return [
      {
        label: getString(`${SUMMARY_STRINGS}.deliveryMethodLabel`),
        value: getString(`${CHOOSE_DELIVERY_STRINGS}.ship.title`),
      },
      {
        label: getString(`${SUMMARY_STRINGS}.addressLabel`),
        value: formatAddressParagraph(shippingAddress),
      },
    ];
  }

  const pickupMethod = getString(`${CHOOSE_DELIVERY_STRINGS}.pickupMethods.${deliveryMethod}`);
  return [
    {
      label: getString(`${SUMMARY_STRINGS}.deliveryMethodLabel`),
      value: getString(`${CHOOSE_DELIVERY_STRINGS}.pickup.title`),
    },
    {
      label: getString(`${LCR_SUMMARY_STRINGS}.buildingLabel`),
      value: shippingAddress.deliveryBuilding
        ? `${pickupMethod} (${shippingAddress.deliveryBuilding})`
        : pickupMethod,
    },
  ];
};

export const toLcrTrackingView = (order: LcrOrder): OrderTrackingView => ({
  orderNumber: order.orderId,
  steps: lcrProgressFor(order),
  item: orderedItem(order),
  summaryRows: [
    {
      label: getString(`${SUMMARY_STRINGS}.replacedDeviceLabel`),
      value: deviceName(order.replacedDevice),
    },
    ...deliveryRows(order.submission),
  ],
});
